import React, { useEffect, useState } from "react";
import useAssetsData from "@/src/useData/useAssetsData";
import S from "./AllAssets.styled";
import { Icon, LoadMoreButton, TextButton } from "@/styles/components";
import { IWPLink } from "@/src/types";
import { Flex, MainInner } from "@/styles/global";
import { H3 } from "@/styles/typography";
import { format } from "date-fns";

type Assets = {
  title: string;
  uri: string;
  date: string;
  assetsInfo: {
    file: {
      mimeType: string;
      localFile: {
        publicURL: string;
      };
    };
  };
};

export interface AllAssetsProps {
  blockId: string;
  link: IWPLink;
}

const AllAssets: React.FC<AllAssetsProps> = ({ link, blockId = "" }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [paginatedAssets, setPaginatedAssets] = useState<Assets[]>([]);
  const assets = useAssetsData();

  useEffect(() => {
    const newAssets = assets.slice(0, (currentPage + 1) * 12);
    setPaginatedAssets(newAssets);
  }, [currentPage, assets]);

  return (
    <S.Section id={blockId}>
      <MainInner>
        {link && (
          <TextButton
            wpLink={link}
            color="black"
            underlined
            left={
              <Icon
                src="ArrowLeftOutline"
                width={15}
                margin="0 16px 0 0"
                color="red"
              />
            }
          />
        )}
        <S.Container>
          {paginatedAssets.map((asset, i) => {
            const date = new Date(asset.date);

            return (
              <S.Card
                href={asset.assetsInfo.file.localFile.publicURL}
                target="_blank"
                key={i}
              >
                <Flex $gap={8} $column>
                  <H3 color="creme">{asset.title}</H3>
                  <S.CardDate color="creme">
                    {format(date, "dd MMMM, yyyy")}
                  </S.CardDate>
                </Flex>
                <Icon src="ArrowDown" width={20} color="creme" />
              </S.Card>
            );
          })}
        </S.Container>
        {paginatedAssets.length < assets.length && (
          <Flex $center $width="100%" $margin="24px 0">
            <LoadMoreButton
              label="Load more"
              onClick={() => setCurrentPage((prevPage) => prevPage + 1)}
            />
          </Flex>
        )}
      </MainInner>
    </S.Section>
  );
};

export default AllAssets;
